import React from 'react'
import { useTranslation } from 'react-i18next'
import { PillButton } from '../../../lib/buttons'
import { cventConfig } from '../../../config'

export default function InPersonEventButton({ emphasis = 'high' }) {
  const [t] = useTranslation()

  return (
    <PillButton emphasis={emphasis} to={cventConfig.registrationUrl} linkName="Heading: In-Person Event">
      {t('event.reg.attend.person.register', 'In-Person Event')}
    </PillButton>
  )
}
